export default "__VITE_ASSET__LIzWZqL6__"